import { useState } from "react";
import ColorPallete from "../../../utils/ColorPallete";
import {useDispatch, useSelector} from 'react-redux';
import EditableInput from "../../../utils/EditableInput";
import {updateElement} from "../../../utils/UpdateFunctions";
import { editElement } from "../../../../actions/UserActions";
function LinkElementOptions() {
	const dispatch = useDispatch();
	const {currentCampaignId, currentPage, currentElement} = useSelector(state => state.user);
	const [elementCopy, setElementCopy] = useState(JSON.parse(JSON.stringify(currentElement)));
	const {background, textAlign, marginTop, target, url, text, textColor} = elementCopy;
	const update = (key, value) => {
		if(key === 'marginTop') value += 'px';
		elementCopy[key] = value;
		updateElement(currentCampaignId, currentPage, elementCopy.id, elementCopy, currentElement, setElementCopy, dispatch, editElement)
	};
	return (
		<div>
			<div className="campaign__option">
				<label className="text--bold">Top Margin (pixels)</label>
				<div className="font--12 text--muted">The space the element has from the top</div>
				<EditableInput item="marginTop" type="number" startValue={marginTop.substring(0, marginTop.length - 2)} updateAction={update} placeholder="0" />
			</div>
			<div className="flex flex--row flex--wrap">
				<div className="campaign__option mtop--15 flex--50">
					<label className="text--bold">Background color</label>
					<ColorPallete item="background" dropdown={true} value={background} type={'rgba'} updateAction={update} />
				</div>
				<div className="campaign__option mtop--15 flex--50 mleft--5">
					<label className="text--bold">Text color</label>
					<ColorPallete item="textColor" dropdown={true} value={textColor} type={'hex'} updateAction={update} />
				</div>
			</div>
			<div className="campaign__option mtop--15">
				<label className="text--bold">Text</label>
				<div className="text--muted font--12">Choose what the users see. It can be something else than an ugly url</div>
				<EditableInput item="text" type="text" startValue={text} updateAction={update} placeholder="Click the link..." />
			</div>
			<div className="campaign__option mtop--15">
				<label className="text--bold">Url</label>
				<div className="text--muted font--12">This is the actual url the users will be redirected to</div>
				<EditableInput item="url" type="text" startValue={url} updateAction={update} placeholder="Click the link..." />
			</div>
			<div className="campaign__option mtop--15">
				<label className="text--bold">Link behaviour</label>
				<div className="flex flex--row">
					<button className={ target === 'self' ? 'btn btn-primary' : 'btn btn-secondary'} onClick={() => update('target', 'self')}>Same window</button>
					<button className={ target === 'newTab' ? 'btn btn-primary' : 'btn btn-secondary'} onClick={() => update('target', 'newTab')}>New window</button>
				</div>
			</div>
			<div className="campaign__option mtop--15">
				<label className="text--bold">Text align</label>
				<div className="flex flex--row">
					<div className={textAlign === 'left' ? 'btn btn-primary' : 'btn btn-secondary'}  onClick={() => update('textAlign', 'left')}>Left</div>
					<div className={textAlign === 'center' ? 'btn btn-primary' : 'btn btn-secondary'}  onClick={() => update('textAlign', 'center')}>Center</div>
					<div className={textAlign === 'right' ? 'btn btn-primary' : 'btn btn-secondary'}  onClick={() => update('textAlign', 'right')}>Right</div>
				</div>
			</div>
		</div>
	);
}

export default LinkElementOptions;
